import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBulb$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBulb extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8d5db74610b6be9f8bd2bc0ff4d70b859d5d22de', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ebf016c5baa2baf6c89d090af738212b30bd1f0e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5f5ba43caab16a2b625ab655227a28ee249de848', d: "M9 19.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V19H9z", fill: "currentColor" }), h("path", { key: '82adcfe7b7de5f4c9866f23029c320fd1d1a31fe', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17 10.318c0 1.773-.764 2.807-1.528 3.841-.689.933-1.378 1.865-1.506 3.34a.537.537 0 0 1-.521.501h-3.89a.537.537 0 0 1-.52-.501c-.13-1.475-.818-2.407-1.507-3.34C6.764 13.125 6 12.091 6 10.32 6 6.772 9.056 5 11.5 5S17 6.773 17 10.318m-1.5 0c0 1.183-.44 1.87-1.124 2.8q-.065.09-.134.181c-.574.773-1.315 1.772-1.636 3.201h-.356v-5.75a.75.75 0 0 0-1.5 0v5.75h-.356c-.321-1.429-1.062-2.428-1.636-3.2l-.134-.182c-.685-.93-1.124-1.617-1.124-2.8 0-2.466 2.108-3.818 4-3.818s4 1.352 4 3.818", fill: "currentColor" }), h("path", { key: '66f139012249d83d50f65b815f1790a7576a0e33', d: "M11.5 1a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 11.5 1M21 9.75a.75.75 0 0 0-.75-.75h-.5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 .75-.75M3.25 9a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5zm2.53-5.28a.75.75 0 0 0-1.06 1.06l.353.354a.75.75 0 1 0 1.06-1.06zm12.504 0a.75.75 0 0 0-1.06 0l-.354.353a.75.75 0 0 0 1.06 1.06l.354-.353a.75.75 0 0 0 0-1.06", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-bulb", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bulb"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bulb":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBulb$1);
            }
            break;
    } });
}

const CosmosIconBulb = CosmosIconBulb$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBulb, defineCustomElement };
